import textEditForm from 'formiojs/components/textfield/TextField.form';

export default function(...extend) {
    return textEditForm([
        {
            key: 'display',
            components: [
                {
                    key: 'inputMask',
                    ignore: true,
                },
                {
                    key: 'allowMultipleMasks',
                    ignore: true,
                },
                {
                    key: 'showWordCount',
                    ignore: true
                },
                {
                    key: 'showCharCount',
                    ignore: true
                },
                {
                    key: 'spellcheck',
                    ignore: true
                },
                {
                    key: 'prefix',
                    ignore: true
                },
                {
                    key: 'suffix',
                    ignore: true
                },
                {
                    key: 'autocomplete',
                    ignore: true
                },
                {
                    key: 'widget.type',
                    ignore: true
                },
                {
                    key: 'widget',
                    ignore: true
                },
                {
                    label: 'Flag as Project Sponsor on Dashboard',
                    widget: 'html5',
                    description: 'Whether this sponsor should be displayed as the Project Sponsor on the Dashboard.',
                    tableView: true,
                    data: {
                        values: [
                            {
                                label: 'No',
                                value: '0',
                            },
                            {
                                label: 'Yes',
                                value: '1'
                            }
                        ]
                    },
                    key: 'display.flagSponsor',
                    type: 'select',
                    input: true,
                    defaultValue: 1
                },
            ],
        },
        {
            key: 'validation',
            components: [
                {
                    key: 'validate.minLength',
                    ignore: true
                },
                {
                    key: 'validate.maxLength',
                    ignore: true
                },
                {
                    key: 'validate.pattern',
                    ignore: true
                },
                {
                    key: 'validate.minWords',
                    ignore: true
                },
                {
                    key: 'validate.maxWords',
                    ignore: true
                },
                {
                    key: 'validate.primaryAffiliations',
                    label: 'Eligible Primary Affiliation(s)',
                    description: 'Restricts what types of people can be looked up to faculty, staff, and/or students.',
                    widget: 'choicesjs',
                    tableView: true,
                    multiple: true,
                    data: {
                        values: [
                            {
                                label: 'Student',
                                value: 'student'
                            },
                            {
                                label: 'Faculty',
                                value: 'faculty'
                            },
                            {
                                label: 'Staff',
                                value: 'staff'
                            }
                        ]
                    },
                    validate: {
                        onlyAvailableItems: true
                    },
                    type: 'select',
                    input: true
                },
                {
                    label: 'Always Allow Non-NU Users',
                    widget: 'html5',
                    description: 'Whether non-NU users that have been invited to the platform should be searchable.',
                    tableView: true,
                    data: {
                        values: [
                            {
                                label: 'Yes',
                                value: '1'
                            },
                            {
                                label: 'No',
                                value: '0'
                            }
                        ]
                    },
                    key: 'validate.alwaysAllowNonNuUsers',
                    type: 'select',
                    input: true,
                    defaultValue: 1
                },
                {
                    key: 'errors',
                    components: [
                        {
                            key: "errors",
                            defaultValue: {
                                "required": "You must enter a valid netID, email address, or student/employee ID."
                            },
                        }
                    ]
                }
            ],
        }
    ], ...extend);
}
